import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.js'
import {ColorManagement} from 'three'
import {KeyboardControls, Loader} from '@react-three/drei'
import Interface from './Interface/Interface'
import {Provider} from 'react-redux'
import store from './store/reduxStore'
import { Suspense } from 'react'

const root = ReactDOM.createRoot(document.querySelector('#root'))

ColorManagement.legacyMode = false

root.render(
    <Provider store={store}>
        <KeyboardControls map={[
            {name: 'forward', keys: ['ArrowUp', 'KeyW']},
            {name: 'backward', keys:['ArrowDown', 'KeyS']},
            {name:'leftward', keys:['ArrowLeft', 'KeyA']},
            {name:'rightward', keys:['ArrowRight', 'KeyD']},
            {name:'jump', keys:['Space']},
        ]}>
            <Canvas
                shadows
                camera={ {
                    fov: 45,
                    near: 0.1,
                    far: 200,
                    position: [ 2.5, 4, 6 ]
                } }
            >
                <Suspense fallback={null}>   
                    <Experience />
                </Suspense>
                
                
            </Canvas>
            <Loader/>
            <Interface/>
        </KeyboardControls>
    </Provider>
)